import React, { useEffect, useState } from "react";
import "./Manage_Address.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faPencil,
  faPencilSquare,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Form, Modal, Button } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useForm, Controller } from "react-hook-form";
import Green_round_btn from "../../../common-components/common_btn/green_round_btn/Green_round_btn";
import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  AllCity,
  allGoogleLocations,
  AllPincode,
  AllState,
  getAllCountries,
} from "../../../../features/master/masterSlice";
import {
  createOrderAddress,
  EditOrderAddress,
  getAllOrderAddress,
  getSingleOrderAddress,
} from "../../../../features/order/orderSlice";
import { deleteUserAddress } from "../../../../features/user/userSlice";
import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";
import Orange_Btn from "../../../common-components/common_btn/orange_btn/Orange_Btn";

const Manage_Address = () => {
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteSuccessModal, setShowDeleteSuccessModal] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);

  const dispatch = useDispatch();
  const allAddress = useSelector((state) => state.order.allOrdersAddress);
  useEffect(() => {
    dispatch(getAllOrderAddress());
  }, [dispatch]);
  const {
    control,
    handleSubmit,
    register,
    reset,
    getValues,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      // name: details.name || "",
      // pincode: details.pincode || "",
      // addressLine1: details.addressLine1 || "",
      // addressLine2: details.addressLine2 || "",
      // landmark: details.landmark || "",
      // city: details.city || "",
      // country: details.country || null,
      // state: details.state || null,
      // defaultAddress: details.defaultAddress || false,
      // instructions: details.instructions || "",
      // contact: details.contact || "",
    },
  });

  const [isEdit, setIsEdit] = useState(false);

  const countries = useSelector((state) => state.master.all_country);
  const states = useSelector((state) => state.master.all_state);
  const cities = useSelector((state) => state.master.all_city);
  const pincodes = useSelector((state) => state.master.all_pincode);

  useEffect(() => {
    dispatch(getAllCountries());
    console.log("countries", states);
  }, [dispatch]);

  const handleCountryChange = (selectedOption) => {
    setValue("country_id", selectedOption?.value);
    setValue("state_id", null);
    setValue("city_id", null);
    setValue("pincode_id", null);
    dispatch(AllState({ countryId: selectedOption.value }));
  };

  const handleStateChange = (selectedOption) => {
    setValue("state_id", selectedOption.value);
    setValue("city_id", null);
    setValue("pincode_id", null);
    dispatch(AllCity({ stateId: selectedOption.value }));
  };

  const handleCityChange = (selectedOption) => {
    setValue("city_id", selectedOption?.value);
    setValue("pincode_id", null);
    dispatch(AllPincode({ cityId: selectedOption.value }));
  };

  const handlePincodeChange = (selectedOption) => {
    setValue("pincode_id", selectedOption?.value);
  };

  const allplaces = useSelector((state) => state.master.places);

  const [search, setSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (search && search.trim().length >= 2) {
        dispatch(allGoogleLocations(search));
        setShowDropdown(true);
      } else {
        setShowDropdown(false);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [search, dispatch]);

  const onSubmit = async (data) => {
    const DataToSend = new FormData();
    DataToSend.append("lat", data?.lat);
    DataToSend.append("long", data?.long);
    DataToSend.append("country_id", data?.country_id);
    DataToSend.append("state_id", data?.state_id);
    DataToSend.append("first_name", data?.name);
    DataToSend.append("pincode_id", data?.pincode_id);
    DataToSend.append("street", data?.street);
    DataToSend.append("building", data?.building);
    DataToSend.append("city_id", data?.city_id);
    DataToSend.append("contact_no", data?.contact_no);
    DataToSend.append("apartment", data?.landmark);
    const res = await dispatch(createOrderAddress({ data: DataToSend }));
    if (res.meta?.requestStatus === "fulfilled") {
      setShowSucsessModal(true);
      setTimeout(() => {
        setShowSucsessModal(false);
        reset({
          country_id: null,
          state_id: null,
          name: "",
          pincode_id: null,
          street: "",
          building: "",
          city_id: null,
          contact_no: "",
          landmark: "",
        });
        setIsEdit(false);
        reset();
      }, 4000);
    } else if (res.meta?.requestStatus === "rejected") {
    }
    setIsEdit(false);
    reset();
    await dispatch(getAllOrderAddress());
  };

  const [isUpdate, setIsUpdate] = useState(false);

  const [id, setId] = useState();

  const handleEdit = async (data) => {
    const res = await dispatch(getSingleOrderAddress({ id: data.id }));

    const address = res?.payload?.data;

    setId(data.id);
    setIsUpdate(true);
    setIsEdit(true);

    dispatch(AllState({ countryId: address.country_id }));
    dispatch(AllCity({ stateId: address.state_id }));
    dispatch(AllPincode({ cityId: address.city_id }));

    reset(address);
  };

  const handleUpdate = async (data) => {
    const DataToSend = new FormData();
    DataToSend.append("lat", data?.lat);
    DataToSend.append("long", data?.long);
    DataToSend.append("country_id", data?.country_id);
    DataToSend.append("state_id", data?.state_id);
    DataToSend.append("first_name", data?.name);
    DataToSend.append("pincode_id", data?.pincode_id);
    DataToSend.append("street", data?.street);
    DataToSend.append("building", data?.building);
    DataToSend.append("city_id", data?.city_id);
    DataToSend.append("contact_no", data?.contact_no);
    DataToSend.append("apartment", data?.landmark);
    const res = await dispatch(EditOrderAddress({ id, data: DataToSend }));

    if (res.meta?.requestStatus === "fulfilled") {
      setShowSucsessModal(true);
      setShowSucsessModal(true);
      setTimeout(() => {
        setShowSucsessModal(false);
        setIsEdit(false);
        setIsUpdate(false);
        reset({
          country_id: null,
          state_id: null,
          name: "",
          pincode_id: null,
          street: "",
          building: "",
          city_id: null,
          contact_no: "",
          landmark: "",
        });
      }, 3000);
    } else if (res.meta?.requestStatus === "rejected") {
    }
    // setIsEdit(false);
    // reset();
  };

  const handleCancel = async () => {
    setIsEdit(false);
    setIsUpdate(false);
    setId(null);

    reset({
      country_id: null,
      state_id: null,
      city_id: null,
      pincode_id: null,
      name: "",
      building: "",
      street: "",
      landmark: "",
      contact_no: "",
    });

    await dispatch(getAllOrderAddress());
  };

  // const handleDelete = async (id) => {
  //   await dispatch(deleteUserAddress(id));
  //   await dispatch(getAllOrderAddress());
  // };

  const handleDelete = async () => {
    const res = await dispatch(deleteUserAddress(selectedAddressId));

    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllOrderAddress());

      setShowDeleteModal(false);
      setShowDeleteSuccessModal(true);
      setSelectedAddressId(null);
    }
  };

  const handleAdd = () => {
    setIsUpdate(false);
    setId(null);

    reset({
      country_id: null,
      state_id: null,
      city_id: null,
      pincode_id: null,
      name: "",
      building: "",
      street: "",
      landmark: "",
      contact_no: "",
    });

    setIsEdit(true);
  };

  const blackStyles: StylesConfig<ColourOption> = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#000",
      borderColor: "#444",
      color: "#fff",
    }),

    menu: (styles) => ({
      ...styles,
      backgroundColor: "#000",
    }),

    option: (styles, { isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? "#111" // selected option background
          : isFocused
          ? "#222" // hover background
          : "#000", // default option background

        color: isDisabled ? "#555" : "#fff", // white text for all

        cursor: isDisabled ? "not-allowed" : "pointer",

        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled
            ? isSelected
              ? "#111"
              : "#333" // active click state
            : undefined,
        },
      };
    },

    singleValue: (styles) => ({
      ...styles,
      color: "#fff", // selected value text
    }),

    placeholder: (styles) => ({
      ...styles,
      color: "#777", // placeholder light gray
    }),

    input: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };

  return (
    <>
      {!isEdit && (
        <div className="add_address_radio_box">
          <Form>
            {allAddress?.data?.length > 0 && (
              <h4 className="para_secondary_text mb-3">Your Saved Address</h4>
            )}
            <div className="row">
              {/* Map saved addresses here instead of hardcoded */}
              {allAddress?.data?.map((val, index) => {
                const parts = [
                  val?.building,
                  val?.street,
                  val?.apartment,
                  val?.Users_Address_Detail?.Country?.name,
                  val?.Users_Address_Detail?.State?.name,
                  val?.Users_Address_Detail?.City?.name,
                  val?.Users_Address_Detail?.Pincode?.name,
                ];
                const fullAddress = parts.filter(Boolean).join(", ");
                return (
                  <>
                    {/* <h4 className="para_secondary_text">Your Saved Address</h4> */}
                    <div
                      className="col-lg-6 col-md-6 col-sm-6 mb-2"
                      key={val.id || index}
                    >
                      <div className="address_radio_box_holder">
                        <p className="address_text">{fullAddress}</p>
                        <div className="icons_holder">
                          <div
                            className="icon_holder"
                            onClick={() => {
                              handleEdit(val);
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faPenToSquare}
                              className="edit_icon"
                            />
                          </div>
                          <div
                            className="icon_holder"
                            // onClick={() => {
                            //   handleDelete(val.id);
                            // }}
                            onClick={() => {
                              setSelectedAddressId(val.id);
                              setShowDeleteModal(true);
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faTrash}
                              className="delete_icon"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}

              {/* <div className="col-lg-6 col-md-6 col-sm-6 mb-2">
                <div className="address_radio_box_holder">
                  <p className="address_text">Near the Old Temple, Village Kothrud, Taluka Haveli, Pune District, Maharashtra 411038, India</p>
                  <div className="icons_holder">
                    <div className="icon_holder" onClick={handleEdit}>
                      <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="edit_icon"
                      />
                    </div>
                    <div className="icon_holder">
                      <FontAwesomeIcon icon={faTrash} className="delete_icon" />
                    </div>
                  </div>
                </div>
              </div>*/}
            </div>

            {allAddress?.data?.length === 0 && (
              <div className="no-address-card">
                <div className="no-address-icon">
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className="inner_icon"
                  />
                </div>

                <h5>No Address Found</h5>

                <p>
                  You haven't added any address yet. Add your address to
                  continue.
                </p>
              </div>
            )}

            <div className="add-address-btn-wrapper">
              <button
                type="button"
                className="add-address-btn"
                onClick={handleAdd}
              >
                <i className="fa-solid fa-plus me-2"></i>
                Add New Address
              </button>
            </div>
          </Form>
        </div>
      )}

      {isEdit && (
        <section className="Manage_Address Personal_Info theme_bg_primary_colour">
          {/* <div className="icons_holder">
          <div className="icon_holder">
            <FontAwesomeIcon icon={faPenToSquare} className="edit_icon" />
          </div>

          <div className="icon_holder">
            <FontAwesomeIcon icon={faTrash} className="delete_icon" />
          </div>
        </div> */}

          <div className="personal_info_form">
            <Form>
              <div className="row">
                <div className="">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Full Name *</Form.Label>
                    <Form.Control
                      {...register("name", {
                        required: "Full name is required",

                        maxLength: {
                          value: 60,
                          message: "Full name cannot exceed 60 characters",
                        },
                      })}
                      onChange={(e) => {
                        setValue("name", e.target.value);
                        clearErrors("name");
                      }}
                      placeholder="Enter Full Name"
                    />
                    {errors.name && (
                      <p className="error__feedback">{errors.name.message}</p>
                    )}
                  </Form.Group>
                </div>
                <div className="">
                  <Form.Group className="form__item input_group position-relative">
                    <Form.Label>Address *</Form.Label>

                    <Form.Control
                      placeholder="Enter Area"
                      value={search}
                      {...register("building", {
                        required: "Area is required",
                      })}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSearch(value);
                        setValue("building", value, {
                          shouldValidate: true,
                        });
                      }}
                    />

                    {errors.building && (
                      <p className="error__feedback">
                        {errors.building.message}
                      </p>
                    )}

                    {showDropdown && allplaces?.length > 0 && (
                      <div
                        className="position-absolute bg-white border rounded shadow w-100"
                        style={{
                          zIndex: 1000,
                          maxHeight: "250px",
                          overflowY: "auto",
                        }}
                      >
                        {allplaces.map((place) => (
                          <div
                            key={place.place_id}
                            className="p-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setSearch(place.description);
                              setValue("building", place.address, {
                                shouldValidate: true,
                              });

                              // Optional: fill other fields
                              setValue("city_id", place.city);
                              setValue("state_id", place.state);
                              setValue("country_id", place.country);
                              setValue("pincode_id", place.pincode);
                              setValue("lat", place.location.lat);
                              setValue("long", place.location.lng);

                              setShowDropdown(false);
                            }}
                          >
                            {place.address}
                          </div>
                        ))}
                      </div>
                    )}
                  </Form.Group>
                </div>

                <div className="">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Apartment</Form.Label>
                    <Form.Control
                      type="text"
                      name="street"
                      placeholder="Enter Address"
                      {...register("street")}
                      onChange={(e) => {
                        setValue("street", e.target.value);
                        clearErrors("street");
                      }}
                    />
                  </Form.Group>
                </div>

                <div className="">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Landmark</Form.Label>
                    <Form.Control
                      type="text"
                      name="landmark"
                      placeholder="Enter Address"
                      {...register("landmark")}
                      onChange={(e) => {
                        setValue("landmark", e.target.value);
                        clearErrors("landmark");
                      }}
                    />
                  </Form.Group>
                </div>

                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Country / Region</Form.Label>
                    <Form.Control
                      {...register("country_id", {
                        required: "Country is required",
                      })}
                      placeholder="Country"
                    />
                    {errors.country_id && (
                      <p className="error__feedback">
                        {errors.country_id.message}
                      </p>
                    )}
                  </Form.Group>
                </div>
                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>State</Form.Label>
                    <Form.Control
                      {...register("state_id", {
                        required: "State is required",
                      })}
                      placeholder="State"
                    />
                    {errors.state_id && (
                      <p className="error__feedback">
                        {errors.state_id.message}
                      </p>
                    )}
                  </Form.Group>
                </div>
                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      {...register("city_id", {
                        required: "City is required",
                      })}
                      placeholder="City"
                    />
                    {errors.city_id && (
                      <p className="error__feedback">
                        {errors.city_id.message}
                      </p>
                    )}
                  </Form.Group>
                </div>
                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Pincode</Form.Label>
                    <Form.Control
                      {...register("pincode_id", {
                        required: "Pincode is required",
                      })}
                      placeholder="Pincode"
                    />
                    {errors.pincode_id && (
                      <p className="error__feedback">
                        {errors.pincode_id.message}
                      </p>
                    )}
                  </Form.Group>
                </div>

                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Contact *</Form.Label>
                    <Controller
                      name="contact_no"
                      control={control}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault(); // Block non-numeric input
                        }
                      }}
                      rules={{
                        required: "Contact is required",

                        minLength: {
                          value: 12,
                          message: "Mobile number must be 10 digits",
                        },
                        maxLength: {
                          value: 12,
                          message: "Mobile number must be 10 digits",
                        },
                        pattern: {
                          value: /^[6-9]\d{11}$/,
                          message: "Enter valid 10-digit contact number",
                        },
                      }}
                      onChange={(e) => {
                        setValue("contact_no", e.target.value);
                        clearErrors("contact_no");
                      }}
                      render={({ field }) => (
                        <PhoneInput
                          {...field}
                          country="in"
                          onChange={(value) => field.onChange(value)}
                          inputClass="form-control"
                        />
                      )}
                    />
                    {errors.contact_no && (
                      <p className="error__feedback">
                        {errors.contact_no.message}
                      </p>
                    )}
                  </Form.Group>
                </div>

                {/* <div className="">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>
                      Flat, House No., Building, Company, Apartment
                    </Form.Label>
                    <Form.Control
                      placeholder="Enter Flat, House No., Building, Company, Apartment"
                      {...register("building", {
                        required: "Address line is required",
                      })}
                      onChange={(e) => {
                        setValue("building", e.target.value);
                        clearErrors("building");
                      }}
                    />
                    {errors.building && (
                      <p className="error__feedback">
                        {errors.building.message}
                      </p>
                    )}
                  </Form.Group>
                </div> */}

                {/* <div className="">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Apartment</Form.Label>
                    <Form.Control
                      type="text"
                      name="street"
                      placeholder="Enter Address"
                      {...register("street")}
                      onChange={(e) => {
                        setValue("street", e.target.value);
                        clearErrors("street");
                      }}
                    />
                  </Form.Group>
                </div>

                <div className="">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Landmark</Form.Label>
                    <Form.Control
                      type="text"
                      name="landmark"
                      placeholder="Enter Address"
                      {...register("landmark")}
                      onChange={(e) => {
                        setValue("landmark", e.target.value);
                        clearErrors("landmark");
                      }}
                    />
                  </Form.Group>
                </div> */}

                {/* 
              <div className="">
                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Check
                    type="checkbox"
                    label="Make this my default address"
                    name="timeframe"
                    value="Male"
                    className="custom-radio-green"
                  />
                </Form.Group>
              </div> */}

                <div className="form_footer">
                  <div className="btns_holder">
                    <div className="cancel_btn">
                      <Green_round_btn
                        btnText="Cancel"
                        onClick={handleCancel}
                      />
                    </div>

                    {isUpdate ? (
                      <div className="save_btn">
                        <Green_btn
                          btnText="Update"
                          onClick={handleSubmit(handleUpdate)}
                        />
                      </div>
                    ) : (
                      <div className="save_btn">
                        <Green_btn
                          btnText="Save"
                          onClick={handleSubmit(onSubmit)}
                        />
                      </div>
                    )}
                  </div>

                  {/* <p className="add_address_text">Add Address</p> */}
                </div>
              </div>
            </Form>
          </div>
        </section>
      )}
      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText={
          isUpdate
            ? "Address Updated Successfully!"
            : "Address Added Successfully!"
        }
      />

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        className="Cancel_Reason_Modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Address</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure you want to delete this address?</Modal.Body>

        <Modal.Footer>
          <div className="btns_holder">
            <Green_btn
              btnText={"No"}
              onClick={() => setShowDeleteModal(false)}
            />

            <Orange_Btn btnText={"Yes"} onClick={handleDelete} />
          </div>
        </Modal.Footer>
      </Modal>

      <Success_Modal
        show={showDeleteSuccessModal}
        onHide={() => setShowDeleteSuccessModal(false)}
        successText="Address deleted successfully!"
      />
    </>
  );
};

export default Manage_Address;
